export type MemberType = 'participant' | 'non_participant';
export type PeopleFilter = 'all' | MemberType;

export function getMemberTypeLabel(memberType: MemberType) {
  return memberType === 'participant' ? 'Participant' : 'Non Participant';
}
